module.exports = __webpack_public_path__ + "static/media/checklist.820ae948.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/checklist.svg
// module id = 1488
// module chunks = 50